export const environment = {
    production: true,
    API_BASE_URL: 'https://api.doorsurvey.co.uk',
    WS_URL: 'wss://api.doorsurvey.co.uk/ws',
};
